import { useEffect, useRef } from 'react';
import Cookies from 'js-cookie';

/**
 * Подключается к WebSocket-серверу и подписывается на события филиала.
 * Протокол: ws://host:9300/?token=<crm_token>&branch=<branchId>&aud=crm
 *
 * @param {string} branchId
 * @param {(action: string, payload: unknown) => void} onEvent
 */
export function useBranchRealtime(branchId, onEvent) {
  const handlerRef = useRef(onEvent);
  useEffect(() => {
    handlerRef.current = onEvent;
  }, [onEvent]);

  useEffect(() => {
    if (!branchId) return undefined;
    const token = Cookies.get('crm_token');
    if (!token) return undefined;

    const wsHost = (import.meta.env.VITE_WS_URL ?? `ws://${window.location.hostname}:9300`)
      .replace(/\/$/, '');
    const url = `${wsHost}/?aud=crm&branch=${encodeURIComponent(branchId)}&token=${encodeURIComponent(token)}`;

    let ws;
    let closedByClient = false;
    let reconnectTimer = null;

    const connect = () => {
      ws = new WebSocket(url);
      ws.onmessage = (e) => {
        try {
          const msg = JSON.parse(e.data);
          handlerRef.current?.(msg.action, msg.payload);
        } catch {
          // ignore bad messages
        }
      };
      ws.onclose = () => {
        if (closedByClient) return;
        reconnectTimer = setTimeout(connect, 5000);
      };
      ws.onerror = () => {
        try { ws.close(); } catch { /* noop */ }
      };
    };

    connect();

    return () => {
      closedByClient = true;
      if (reconnectTimer) clearTimeout(reconnectTimer);
      try { ws?.close(); } catch { /* noop */ }
    };
  }, [branchId]);
}
